import { ClickTrackProvider, LinkClickData } from '@sxm-core/tracking/click-track-provider';
import { EventTrackingService } from './event-tracking.service';

export const clickTrackProviderFactoryAdobeEddl = (): ClickTrackProvider => {
    const eventTrackingService = new EventTrackingService();
    return {
        trackLinkClick: (data: LinkClickData) => {
            eventTrackingService.clickTrack(data);
        },
    };
};
